import { useEffect } from 'react';

export default function usePageMeta({ title, description, ogTitle, ogDescription, ogImage }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      const ogTitleTag = document.querySelector('meta[property="og:title"]');
      const twitterTitleTag = document.querySelector('meta[name="twitter:title"]');
      if (ogTitleTag) ogTitleTag.setAttribute('content', ogTitle || title);
      if (twitterTitleTag) twitterTitleTag.setAttribute('content', ogTitle || title);
    }

    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) metaDescription.setAttribute('content', description);
    }

    if (ogDescription) {
      const ogDescTag = document.querySelector('meta[property="og:description"]');
      const twitterDescTag = document.querySelector('meta[name="twitter:description"]');
      if (ogDescTag) ogDescTag.setAttribute('content', ogDescription);
      if (twitterDescTag) twitterDescTag.setAttribute('content', ogDescription);
    }

    if (ogImage) {
      const ogImageTag = document.querySelector('meta[property="og:image"]');
      const twitterImageTag = document.querySelector('meta[name="twitter:image"]');
      if (ogImageTag) ogImageTag.setAttribute('content', ogImage);
      if (twitterImageTag) twitterImageTag.setAttribute('content', ogImage);
    }
  }, [title, description, ogTitle, ogDescription, ogImage]);
}